<template>
  <div id="NewTeam">
        <vs-table v-model="selected" :data="team">
            <template slot="thead">
                <vs-th>{{$t('Businesses.Table.Name')}}</vs-th>
                <vs-th>{{$t('Businesses.Table.Email')}}</vs-th>
                <vs-th>{{$t('Businesses.Table.Phone')}}</vs-th>
                <vs-th>Role</vs-th>
                <vs-th>{{$t('Businesses.Table.Options')}}</vs-th>
            </template>
            
            <template>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in team">
                    <vs-td :data="tr.fname">{{tr.fname}} {{tr.lname}}</vs-td>
                    <vs-td :data="tr.email">{{tr.email}}</vs-td>
                    <vs-td :data="tr.telephone">{{tr.telephone}}</vs-td>
                    <vs-td v-if="tr.roles.length" :data="tr.roles">{{tr.roles[0].name}}</vs-td>
                    <vs-td v-else>--</vs-td>
                    <vs-td class="btn-alignment">
                        <!-- <vs-button radius color="warning" type="border" id="edit-team-button" icon="edit" @click="openUpdatePrompt()"></vs-button> -->
                        <vs-button  
                            radius
                            color="dark"
                            type="border"
                            icon="lock"
                            @click="neww.id = tr.id;activePromptPW = true"
                        ></vs-button>
                        <!-- <vs-button radius color="danger" type="border" icon="delete" @click="deleteMember()"></vs-button> -->
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>


            <vs-prompt
                    color="primary"
                    @accept="changePassword"
                    :active.sync="activePromptPW"
                    :title="$t('Profile.UpdatePasswordButton')"
                    :accept-text="$t('Profile.UpdatePasswordPrompt.ConfirmButton')"
                    :cancel-text="$t('Profile.UpdatePasswordPrompt.CancelButton')"
            >
              <div v-bar class="vs-scrollable">
                <div>
                  <div class="con-exemple-prompt px-4 py-3">
                    <vs-row>
                      <vs-col vs-w="12"><vs-input
                              :danger="errors.password"
                              :danger-text="$t('Errors.InvalidPassword')"
                              :label="$t('Profile.NewPassword')"  type="password"  class="w-100 mb-2" 
                              v-model="neww.password"/></vs-col>
                    <vs-row>
                    </vs-row>
                      <vs-col vs-w="12"><vs-input
                             :danger="errors.password_confirm"
                             :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.PasswordConfirm')})"
                             :label="$t('Profile.PasswordConfirm')" type="password"  class="w-100 mb-2" 
                             v-model="neww.confirm_password"/></vs-col>
                    </vs-row>
                  </div>
                </div>
              </div>
            </vs-prompt>
  </div>
</template>

<script>
import { businessService } from '/src/_services'

export default({
  data:()=>({
    team: null,
    activePromptPW: false,
    selected: null,
    selected_member: null,
    errors:{
        password : false,
        password_confirm : false
    },
    neww:{
        id: null,
        password: "",
        confirm_password: "",
    }
  }),
  methods:{
    validateFields() {
      this.errors.password = (!this.neww.password || this.neww.password.length < 8 || !this.neww.password.match(/[a-z]/) && !this.neww.password.match(/[A-Z]/) || !this.neww.password.match(/\d/) || !this.neww.password.match(/[^a-zA-Z\d]/)) ? true : false;
      this.errors.password_confirm = this.neww.password!=this.neww.confirm_password;

      let {password, password_confirm} = this.errors;

      return !(password || password_confirm)
    },
    changePassword(){
        if( this.validateFields() ){
            this.showLoading()
            businessService.changePassword(this.neww).then(function(){
                this.notify(
                    this.$t("Toasts.Successful"),
                    this.$t("Customer.EditCustomerPrompt.ToastSuccessMessage"),
                    "success"
                );
            }.bind(this)).catch(function(){
                this.notify(
                    this.$t("Toasts.Error"),
                    this.$t("Customer.EditCustomerPrompt.ToastFailMessage"),
                    "danger"
                );
            }.bind(this)).finally(function(){
                this.hideLoading()
            }.bind(this))
        }else{
            this.activePromptPW = true;
        }
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text
      });
    },
    showLoading(){
      this.$vs.loading({
        container: '#NewTeam',
        scale: 0.6
      });
    },
    hideLoading(){
      this.$vs.loading.close('#NewTeam > .con-vs-loading')
    },
  },
  mounted(){
    businessService.getMembers(this.$route.params.id).then(function(data){
        this.team = data.data
        this.neww.confirm_password = null
        this.neww.password = null
    }.bind(this))
  },
})
</script>
